/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { BaseModel } from "@Internal/Models";
import { ICustomDate } from "@Internal/Contracts";

import { Identifiable, Named } from "Shared/Contracts";

import BaseRole from "./Role";

export default class BaseUser extends BaseModel implements Identifiable, Named {
    Email?: string;
    FirstName?: string;
    LastName?: string;
    Locale?: string;

    /* Console staff lifecycle / contact / role. */
    Phone?: string;
    State?: string;
    RoleId?: number;
    Role?: BaseRole;
    CreatedAt?: ICustomDate;
    LastActivityAt?: ICustomDate;

    /* Whether two-factor enrollment is complete. Safe to expose (it carries no secret); the secret
       and recovery codes live on the backend User model only. */
    TotpEnabled?: boolean;

    constructor(
        id: number,
        email?: string,
        firstName?: string,
        lastName?: string,
        locale?: string
    ) {
        super( id );

        this.Email = email;
        this.FirstName = firstName;
        this.LastName = lastName;
        this.Locale = locale;
    }

    get Id(): number { return this.id; }

    get Name(): string {
        const name = [];

        if( this.FirstName !== undefined && this.FirstName !== "" )
            name.push( this.FirstName );

        if( this.LastName !== undefined && this.LastName !== "" )
            name.push( this.LastName );

        return name.join( " " );
    }

    get Initials(): string {
        let name = "";

        if( this.FirstName !== undefined )
            name += this.FirstName.trim().charAt( 0 );

        if( this.LastName !== undefined )
            name += this.LastName.trim().charAt( 0 );

        return name;
    }
}
